import styled from 'styled-components/macro';

export const Section = styled.div`
  background: ${props => props.color};
`